import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiVerifyOtp } from '../services/auth';
import { useAuth } from '../context/AuthContext';

export default function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useAuth();
  
  const { verify_email, dev_otp } = location.state || {};
  const [otp, setOtp] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  if (dev_otp && otp === '') setOtp(String(dev_otp));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const { user, token } = await apiVerifyOtp({ email: verify_email, otp });
      login(user, token);
      navigate('/account');
    } catch (err) {
      const data = err.response?.data || err;
      setError(data?.message || 'Verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!verify_email) {
    return <p className="text-center mt-10 text-red-500">No email provided. Please go back to login.</p>;
  }

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center bg-[#f6f2ea] px-4 py-12">
      <div className="bg-white w-full max-w-md rounded-xl shadow-sm border border-neutral-200 p-8">
        <h1 className="font-serif text-3xl text-neutral-900 text-center mb-6">Verify OTP</h1>
        <p className="text-sm text-neutral-600 text-center mb-4">
          Enter the 6-digit code sent to <strong>{verify_email}</strong>
        </p>

        {error && <div className="mb-4 text-sm bg-red-50 border border-red-200 text-red-700 rounded-md px-3 py-2">{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            required
            type="text"
            maxLength={6}
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="123456"
            className="mt-1 w-full border border-neutral-300 rounded-md px-3 py-2.5 text-center text-2xl font-bold tracking-widest focus:outline-none focus:border-[#1e3a2b]"
          />
          
          <button disabled={loading} className="mt-6 w-full bg-[#1e3a2b] hover:bg-[#2a5040] text-white font-bold py-3 rounded-md">
            {loading ? 'Verifying...' : 'Verify Code'}
          </button>
        </form>
      </div>
    </div>
  );
}